import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { WsConnectorServiceBase } from './ws-connector-base.service';
import { WsDeviceDto } from '../models/interfaces/ws-device-dto.interface';
import { WsNotificationDto } from '../models/interfaces/ws-notification-dto.interface';
import { NotificationActions } from '../../features/notifications/state/notification.actions';
import { DeviceActions } from '../../features/devices/state/device.actions';
import { WsKillSwitchDto } from '../models/interfaces/ws-kill-switch-dto.interface';
import { KillSwitchActions } from '../../features/dashboard/state/kill-switch.actions';

type WsMessage = WsDeviceDto | WsNotificationDto | WsKillSwitchDto;

@Injectable({
  providedIn: 'root',
})
export class WsConnectorService extends WsConnectorServiceBase<WsMessage> {
  protected override readonly wsPath = 'notifications';
  protected override readonly logLabel = 'WebSocket';

  private store = inject(Store);

  protected override handleMessage(v: WsMessage) {
    if (this.isWsDeviceDto(v)) {
      this.store.dispatch(
        DeviceActions.public.refreshDeviceDataFromWebSocket({ device: v }),
      );
    } else if (this.isWsNotificationDto(v)) {
      this.store.dispatch(
        NotificationActions.public.refreshNotificationDataFromWebSocket({
          notification: v,
        }),
      );
    } else if (this.isWsKillSwitchDto(v)) {
      this.store.dispatch(
        KillSwitchActions.public.refreshKillSwitchDataFromWebSocket(),
      );
    }

    // todo emergencyStop change
    else {
      this.store.dispatch(KillSwitchActions.public.loadEmergencyStop());
    }
  }

  private isWsDeviceDto(v: WsMessage): v is WsDeviceDto {
    return 'lastSeenDate' in v;
  }

  private isWsNotificationDto(v: WsMessage): v is WsNotificationDto {
    return 'readAt' in v;
  }

  private isWsKillSwitchDto(v: WsMessage): v is WsKillSwitchDto {
    return 'state' in v;
  }
}
